export const aiUsageZh = {
  nav: {
    title: 'AI Coding 用量',
    overview: '总览',
    devices: '设备',
    tokens: 'Token 管理',
    dlq: '死信队列',
    me: '我的用量',
    myTokens: '我的 Token',
  },
  kpi: {
    totalCost: '总成本 (USD)',
    totalTokens: '总 Token',
    activeUsers: '活跃员工',
    activeProjects: '活跃项目',
    activeDevices: '活跃设备',
  },
  trend: {
    title: '用量趋势',
    granularity: { day: '日', week: '周', month: '月' },
    groupBy: { none: '不分组', tool: '按工具', model: '按模型', topUser: '按 Top 员工' },
  },
  breakdown: {
    tab: { user: '员工', project: '项目', tool: '工具', model: '模型' },
    column: { name: '名称', tokens: 'Token', cost: '成本 (USD)', share: '占比', deltaPct: '环比' },
  },
  filter: {
    periodLabel: '期间',
  },
  block: {
    activeTitle: '当前 5h 配额窗口',
    recentTitle: '近期 5h 配额窗口',
    active: '（活跃中）',
    elapsed: '已用',
    remaining: '剩余',
    burnRate: '速率',
    colStarted: '开始',
    colDuration: '时长',
    colEvents: 'Event 数',
    colTokens: 'Token',
    colCost: '成本',
  },
  period: {
    today: '今日',
    week: '本周',
    month: '本月',
    year: '本年',
    last7d: '近 7 天',
    last30d: '近 30 天',
    last60d: '近 60 天',
    last90d: '近 90 天',
  },
  empty: {
    inviteToInstall: '还没有员工接入 ffctk，邀请大家安装以查看用量',
    copyInstallCmd: '复制安装命令',
    noOwnToken: '你还没有 token，生成第一个以开始接入',
    createFirst: '生成我的第一个 Token',
    waitingFirstEvent: '等待客户端首次上报，通常 30 秒内',
  },
  token: {
    listTitle: '我的 Token',
    createButton: '生成新 Token',
    createDialogTitle: '生成新 Token',
    nameLabel: 'Token 名称（用于区分多台机器）',
    namePlaceholder: '例如：我的 Mac',
    warningVisibleOnce: '⚠️ 此 Token 仅显示一次，关闭后无法再次查看',
    copyAll: '复制全部命令',
    copyToken: '复制 Token',
    savedClose: '已保存，关闭',
    savedConfirm: '请确认你已经保存 Token，关闭后将无法再次查看',
    revokeConfirmTitle: '撤销 Token',
    revokeConfirmBody: '撤销后该 Token 立即失效，无法恢复。员工需重新生成。',
    revokeReasonLabel: '撤销理由（可选）',
    columnName: '名称',
    columnPrefix: 'Prefix',
    columnLastUsed: '最后使用',
    columnCreated: '创建时间',
    columnStatus: '状态',
    columnActions: '操作',
    statusActive: '生效中',
    statusRevoked: '已撤销',
    actionRevoke: '撤销',
  },
  device: {
    listTitle: '设备管理',
    blockConfirmTitle: '拉黑设备',
    blockReasonLabel: '拉黑理由（必填）',
    blockReasonPlaceholder: '例如：员工离职 / 陌生设备',
    unblockNoteLabel: '备注（可选）',
    columnHostname: '主机名',
    columnUser: '归属员工',
    columnPlatform: '平台',
    columnLastSeen: '最后上报',
    columnStatus: '状态',
    columnActions: '操作',
    statusActive: '活跃',
    statusBlocked: '已拉黑',
    actionBlock: '拉黑',
    actionUnblock: '解黑',
    filterAll: '全部',
    filterActive: '活跃',
    filterBlocked: '已拉黑',
  },
  privacy: {
    faqTitle: '隐私说明',
    whatCollected: '我们采集了：Token 数 / 模型 / 项目路径 / 时间戳。',
    whatNotCollected: '我们从不采集：消息内容 / 提示词 / 工具结果 / 代码内容。',
    exportMyData: '导出我的全部数据',
    requestDeletion: '申请删除我的历史数据',
  },
  toast: {
    tokenCreated: 'Token 已生成',
    tokenRevoked: 'Token 已撤销',
    deviceBlocked: '设备已拉黑',
    deviceUnblocked: '设备已解黑',
    copied: '已复制',
  },
  errors: {
    invalidToken: 'Token 无效或已撤销',
    deviceBlocked: '设备已被拉黑',
    rateLimitExceeded: '请求过于频繁，请稍后重试',
    batchTooLarge: '批量数据超出限制',
    invalidPayload: '数据格式错误',
    networkUnreachable: '网络连接失败',
    tokenNotFound: 'Token 不存在',
    deviceNotFound: '设备不存在',
    tokenAlreadyRevoked: 'Token 已撤销，无需重复操作',
    deviceAlreadyBlocked: '设备已拉黑',
  },
  rich: {
    toolFrequency: '工具调用频次（Top 10）',
    useCount: '调用次数',
    sessionDuration: 'Session 时长分布',
    sessionCount: 'Session 数',
    avgDuration: '平均时长',
    avgTurns: '平均 Turn 数',
    turnGap: 'Turn 间隔分布（思考密度）',
    avgGap: '平均间隔',
    medianGap: '中位间隔',
    serviceTier: '服务等级成本占比',
    stopReason: 'Stop Reason 分布',
    eventCount: '事件数',
    gitBranchHeatmap: '分支烧 Token 热力图（Top 10）',
    tokens: 'Token',
  },
};
